export default "__VITE_ASSET__BmndoR_c__"